export default __webpack_public_path__ + "static/media/ERYC-PEREZ-DE-TAGLE-PHOTOGRAPHY-DINA-MAX-WEDDINGS-NEW-YORK-11162019--550.c4d36d16.jpg";